import React, { useState } from 'react';
import { Loader2, MailCheck } from 'lucide-react'; // MailCheck ikonunu ekledik
import { registerUser, logoutUser, auth } from '../firebase'; 

const RegisterPage = ({ onRegister, onSwitchToLogin, onBack }) => { 
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState(''); 
  const [name, setName] = useState(''); 
  const [school, setSchool] = useState(''); 
  const [loading, setLoading] = useState(false); 
  
  // YENİ: Kayıt başarılı oldu mu state'i
  const [isRegistered, setIsRegistered] = useState(false); 
  
 const handleRegister = async () => { 
    if (!email || !password || !name || !school) return alert("Lütfen tüm alanları doldurunuz."); 
    setLoading(true); 
    try { 
      // 1. Kaydı yap ve maili yolla
      await registerUser(email, password, name, school); 
      
      // 2. Firebase'in otomatik oturumunu kapat
      await logoutUser();

      // 3. App.js'e "Beni doğrulama bekleme ekranına al" de!
      localStorage.setItem('rehber360_view', 'awaiting-verification');
      onRegister('awaiting-verification'); // App.js içindeki setView'i tetikleyecek
      
    } catch (error) { 
      alert("Kayıt hatası: " + error.message); 
    } finally { 
      setLoading(false); 
    } 
  };
  
  // YENİ EKRAN: Eğer kayıt başarılıysa formu gizle, bu uyarıyı göster!
  if (isRegistered) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4 no-print">
        <div className="w-full max-w-md bg-white/90 backdrop-blur-md p-10 rounded-3xl shadow-2xl border border-white/50 text-center animate-in zoom-in duration-500">
          <div className="h-20 w-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm border border-emerald-200">
            <MailCheck className="h-10 w-10" />
          </div>
          <h2 className="text-2xl font-black text-slate-800 mb-2">E-posta Doğrulaması Gerekli</h2>
          <p className="text-slate-600 mb-6 text-sm leading-relaxed">
            Hesabınız başarıyla oluşturuldu! Ancak güvenliğiniz için <strong>{email}</strong> adresine bir doğrulama bağlantısı gönderdik.
            <br/><br/>
            Lütfen e-postanızı (Gereksiz/Spam kutusu dahil) kontrol edin ve bağlantıya tıklayarak hesabınızı aktifleştirin.
          </p>
          <button 
            onClick={onSwitchToLogin} 
            className="w-full py-4 bg-slate-900 hover:bg-slate-800 transition-colors text-white rounded-xl font-bold flex items-center justify-center shadow-lg"
          >
            Doğruladım, Giriş Yap
          </button>
        </div>
      </div>
    );
  }

  // ESKİ EKRAN: Kayıt Formu (Hiçbir şey değişmedi)
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4 no-print">
      <div className="w-full max-w-md bg-white/90 backdrop-blur-md p-10 rounded-3xl shadow-2xl border border-white/50">
        
        <button onClick={onBack} className="mb-6 flex items-center text-xs font-bold text-slate-500 hover:text-blue-600 transition-colors">
          ← GERİ DÖN
        </button>
        
        <h2 className="text-3xl font-black text-slate-800 mb-2 text-center">Yeni Hesap Oluştur</h2>
        <p className="text-center text-slate-500 mb-8 text-sm">Aramıza katılmak için bilgilerinizi girin.</p>
        
        <div className="space-y-4">
          <input 
            type="text" value={name} onChange={e=>setName(e.target.value)} 
            className="w-full px-4 py-3 bg-white rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
            placeholder="Adınız Soyadınız"
          />
          <input 
            type="text" value={school} onChange={e=>setSchool(e.target.value)} 
            className="w-full px-4 py-3 bg-white rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
            placeholder="Okul Adı"
          />
          <input 
            type="email" value={email} onChange={e=>setEmail(e.target.value)} 
            className="w-full px-4 py-3 bg-white rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
            placeholder="E-posta"
          />
          <input 
            type="password" value={password} onChange={e=>setPassword(e.target.value)} 
            className="w-full px-4 py-3 bg-white rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
            placeholder="Şifre"
          />
        </div>
        
        <button 
          onClick={handleRegister} disabled={loading} 
          className="w-full py-4 mt-8 bg-blue-600 hover:bg-blue-700 transition-colors text-white rounded-xl font-bold flex items-center justify-center shadow-lg shadow-blue-200"
        >
          {loading ? <Loader2 className="animate-spin h-5 w-5"/> : "Kayıt Ol"}
        </button>
        
        <div className="mt-8 text-center text-sm text-slate-500">
          Zaten hesabınız var mı? <button onClick={onSwitchToLogin} className="text-blue-600 font-bold hover:underline">Giriş Yap</button>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;